import {DAMAGE_DICE_FACES} from "../../configs/damage";
import {applyDamageDiceFacePenalty} from "./applyDamageDiceFacePenalty";

// Равновероятные исходы грани кости урона при подкрутках броска — ровно то
// распределение, которое дает getDamageDiceRoll(minRoll, rollBonus,
// facePenalty): d6 равновероятен от пола до 6, к нему прибавка, не выше 6,
// затем грань, затем штраф форы новичкам (не ниже -3).
// Пол 3 и +1: [-1, 0, 0, 0]; пол 6 («божество»): [0]; честная кость со
// штрафом 1: [-3, -3, -2, -2, -1, -1]
export const getDamageDiceFaceOutcomes = (minRoll = 1, rollBonus = 0, facePenalty = 0) => {
  const safeMinRoll = Math.min(6, Math.max(1, minRoll));
  const safeRollBonus = Math.max(0, rollBonus || 0);

  const faces = [];
  for (let roll = safeMinRoll; roll <= 6; roll++) {
    faces.push(applyDamageDiceFacePenalty(DAMAGE_DICE_FACES[Math.min(6, roll + safeRollBonus)], facePenalty));
  }
  return faces;
};
